
import React from 'react';
import GridTable from '../../components/GridTable';
import Layout from '../../components/Layout';
import { MODULES } from '../../utils/constants';
import AddCorporateDialog from './AddCorporateDialog';
import { getColumns } from './constants';
import { useCorporateStore } from '../../services/corporates';
import { useAppContext } from '../../services/context/AppContext';
import { getUserCorporateId, isHRUser } from '../../utils/helper';

const Corporates = () => {
    const {
        data,
        totalPages,
        currentPage,
        total,
        isLoading,
        fetchGrid,
        detail,
        onPageChange,
        onDelete,
        limit
    } = useCorporateStore();
    const { userData } = useAppContext();
    const [hrCorporate, setHrCorporate] = React.useState<any | null>(null);
    const [hrLoading, setHrLoading] = React.useState(false);
    const isHR = isHRUser(userData);
    const hrCorporateId = getUserCorporateId(userData);

    React.useEffect(() => {
        const loadCorporateData = async () => {
            if (isHR && hrCorporateId) {
                setHrLoading(true);
                try {
                    const corporate = await detail(hrCorporateId);
                    setHrCorporate(corporate);
                } finally {
                    setHrLoading(false);
                }
                return;
            }

            fetchGrid();
        };

        loadCorporateData();
    }, [detail, fetchGrid, hrCorporateId, isHR]);

    const rowsData = isHR ? (hrCorporate ? [hrCorporate] : []) : data;
    const currentPageValue = isHR ? 1 : currentPage;
    const totalPagesValue = isHR ? 1 : totalPages;
    const totalValue = isHR ? rowsData.length : total;
    const loading = isHR ? hrLoading : isLoading;

    return (
        <Layout appBarTitle="Corporates Management">
            <Layout.Header component={AddCorporateDialog} props={{ module: MODULES.CORPORATE }} />
            <Layout.Body
                component={GridTable}
                props={{
                    data: rowsData,
                    columns: getColumns(currentPageValue, limit),
                    currentPage: currentPageValue,
                    totalPages: totalPagesValue,
                    total: totalValue,
                    loading,
                    onPageChange,
                    module: MODULES.CORPORATE,
                    onDelete: (item: any) => onDelete(item._id),
                    rows: limit
                }}
            />
        </Layout>
    );
};

export default Corporates;
